<script setup lang="ts">
import {defineAsyncComponent, onMounted, ref} from 'vue'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import {determineUspBoxWidth, determineUspImageWidth} from '@/ts/utilities.ts';

const RenderAction = defineAsyncComponent(() => import('@/components/helpers/RenderAction.vue'))

interface Props {
	usp?: object,
	context: string,
	layout: string,
	index?: number,
	productCount?: number
}

const props = defineProps<Props>()
const displayMode = ref('Default');
const image = ref('');
const imageWidth = ref(600);
const imageHeight = ref(375);


const getWrapperClassList = () => {
	let classList: string = '';
	switch (props.context) {
		case 'list':
			classList += ' ' +  determineUspBoxWidth(props.usp?.widthProductListBox, 'col-span-1', props.index);
		case 'content':
			classList += ' ' + determineUspBoxWidth(props.usp?.widthContentBox);
		case 'product':
			classList += ' ' + determineUspBoxWidth(props.usp?.widthProductPageBox);
		default:
			classList += ' ' + determineUspBoxWidth();
	}

	if(displayMode.value === 'ImageLeftSide'){
		classList += ' flex flex-col lg:flex-row lg:overflow-visible pt-0 lg:pt-16 pl-0 lg:pl-16 lg:mb-32 ';
		classList += ` ${props.context == 'list' ? 'bg-white' : 'bg-beige-light'} `;
	}
	return classList;
}

onMounted(() =>{
	displayMode.value = props.usp?.boxDisplayMode;

	let imageSize = determineUspImageWidth();

	switch (props.context) {
		case 'list':
			imageSize = determineUspImageWidth(props.usp?.widthProductListBox);
			imageWidth.value = imageSize.width;
			imageHeight.value = imageSize.height;
			break;
		case 'content':
			imageSize = determineUspImageWidth(props.usp?.widthContentBox);
			imageWidth.value = imageSize.width;
			imageHeight.value = imageSize.height;
			break;
		case 'product':
			imageSize = determineUspImageWidth(props.usp?.widthProductPageBox);
			imageWidth.value = imageSize.width;
			imageHeight.value = imageSize.height;
			break;
	}
	/*
	switch (displayMode.value) {
		case 'ImageLeftSide':
			imageWidth.value = 736;
			imageHeight.value = 460;
			break;
		case 'FullWidthImage':
			imageWidth.value = 1600;
			imageHeight.value = 1000;
			break;
	}

	 */

	console.log(determineUspBoxWidth(props.usp?.widthContentBox));

	image.value = `/Admin/Public/GetImage.ashx?Image=${props.usp?.image}&Width=${imageWidth.value}&height=${imageHeight.value}&Format=webP&Quality=90&Crop=5&resolution=50`;
})

</script>

<template>
	<div
		v-if="props.usp"
		class="rounded border border-grey-light overflow-hidden"
		:class="getWrapperClassList()">
		<div v-if="image"
			 class=" relative "
			 :class="{'h-full': displayMode === 'FullWidthImage', 'bg-white-warm': displayMode !== 'ImageLeftSide', 'overflow-hidden lg:overflow-visible h-full': displayMode === 'ImageLeftSide'}"
		>
			<img
				:src="image"
				:alt="props.usp?.name"
				width="100%"
				class="object-cover object-center h-auto aspect-[16/10]"
				:class="{'h-full w-full': displayMode === 'FullWidthImage', 'rounded lg:row-start-1 lg:col-span-6 -mb-8 lg:-mb-16' : displayMode === 'ImageLeftSide'}"
				loading="lazy"
			>
			<div v-if="displayMode === 'FullWidthImage'" class="absolute inset-0 z-10 flex flex-col items-center justify-center text-white p-8">
				<div v-if="props.usp?.header"
					 class="flex items-center gap-2"
				>
					<font-awesome-icon
						v-if="props.usp?.icon"
						:icon="['fal', props.usp?.icon]"
						class="text-2xl"
					/>
					<h3 class="text-pretty">{{ props.usp?.header }}</h3>
				</div>
				<template v-if="props.usp?.type === 'BULLETS' && props.usp?.bulletUsps">
					<ul class="list-none flex flex-col gap-y-4">
						<li class="flex gap-x-2 items-baseline"
							v-for="(bullet, index) in props.usp?.bulletUsps" :key="index">
							<font-awesome-icon
								v-if="bullet.icon"
								:icon="['fal', bullet.icon]"
							/>
							<p class="flex flex-col">
								<strong>{{ bullet.header }}</strong>
								{{ bullet.teaser }}
							</p>
						</li>
					</ul>
				</template>
				<p v-else>{{ props.usp?.teaser }}</p>
				<RenderAction
					v-if="props.usp?.buttonText && props.usp?.buttonLink"
					action="link"
					theme="link"
					target="external"
					size="none"
					:data="props.usp?.buttonLink"
				>
					{{ props.usp?.buttonText }}
				</RenderAction>
			</div>
		</div>
		<div
			v-if="displayMode === 'ImageLeftSide'"
			class="flex flex-col gap-y-6 p-8 h-full ">
			<div v-if="props.usp?.header"
				 class="flex items-center gap-2"
			>
				<font-awesome-icon
					v-if="props.usp?.icon"
					:icon="['fal', props.usp?.icon]"
					class="text-2xl"
				/>
				<h3 class="text-pretty">{{ props.usp?.header }}</h3>
			</div>
			<template v-if="props.usp?.type === 'BULLETS' && props.usp?.bulletUsps">
				<ul class="list-none flex flex-col gap-y-4">
					<li class="flex gap-x-2 items-baseline"
						v-for="(bullet, index) in props.usp?.bulletUsps" :key="index">
						<font-awesome-icon
							v-if="bullet.icon"
							:icon="['fal', bullet.icon]"
						/>
						<p class="flex flex-col">
							<strong>{{ bullet.header }}</strong>
							{{ bullet.teaser }}
						</p>
					</li>
				</ul>
			</template>
			<p v-else>{{ props.usp?.teaser }}</p>
			<RenderAction
				v-if="props.usp?.buttonText && props.usp?.buttonLink"
				action="link"
				theme="link"
				target="external"
				size="none"
				:data="props.usp?.buttonLink"
			>
				{{ props.usp?.buttonText }}
			</RenderAction>
		</div>
		<div v-if="displayMode === 'Default' " class="flex flex-col gap-y-6 p-8 h-full"
			 :class="props.context == 'list' ? 'bg-white' : 'bg-beige-light'">
			<div v-if="props.usp?.header"
				 class="flex items-center gap-2"
			>
				<font-awesome-icon
					v-if="props.usp?.icon"
					:icon="['fal', props.usp?.icon]"
					class="text-2xl"
				/>
				<h3 class="text-pretty">{{ props.usp?.header }}</h3>
			</div>
			<template v-if="props.usp?.type === 'BULLETS' && props.usp?.bulletUsps">
				<ul class="list-none flex flex-col gap-y-4">
					<li class="flex gap-x-2 items-baseline"
						v-for="(bullet, index) in props.usp?.bulletUsps" :key="index">
						<font-awesome-icon
							v-if="bullet.icon"
							:icon="['fal', bullet.icon]"
						/>
						<p class="flex flex-col">
							<strong>{{ bullet.header }}</strong>
							{{ bullet.teaser }}
						</p>
					</li>
				</ul>
			</template>
			<p v-else>{{ props.usp?.teaser }}</p>
			<RenderAction
				v-if="props.usp?.buttonText && props.usp?.buttonLink"
				action="link"
				theme="link"
				target="external"
				size="none"
				:data="props.usp?.buttonLink"
			>
				{{ props.usp?.buttonText }}
			</RenderAction>
		</div>
	</div>
</template>
